<template>
  <div>
    <QualitaMenu />
  </div>
</template>

<script>
import QualitaMenu from "@/components/Qualita/QualitaMenu";
export default {
  components: {
    QualitaMenu,
  },
};
</script>
